import { render, staticRenderFns } from "./ManagePermissions.vue?vue&type=template&id=5526233c&scoped=true&"
import script from "./ManagePermissions.vue?vue&type=script&setup=true&lang=js&"
export * from "./ManagePermissions.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5526233c",
  null
  
)

export default component.exports